exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".color-picker-drag{z-index:7091;box-shadow:0 4px 12px 1px rgba(0,0,0,.5);border-radius:4px}.color-picker-drag .draggable-place{z-index:7091;width:250px;padding-top:0;background:#f0f0f0;height:25px;border-radius:4px 4px 0 0;cursor:move;display:flex;align-items:center}.color-picker-drag .draggable-place i{height:16px;width:16px;font-size:16px;cursor:pointer;margin-left:calc(100% - 20px)}.color-picker-drag .draggable-place i:hover{border-radius:50%;color:#fff;background-color:#ef5350}.color-picker-drag .sketch-picker{border-radius:0 0 4px 4px!important;box-shadow:none!important;background:#f9f9f9!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?-autoprefixer!./~/postcss-loader/src!./~/less-loader!./src/components/pages/livefeed/Editor/EditorContainer/common/ColorPicker.less
// module id = 1994
// module chunks = 0